// extracted by mini-css-extract-plugin
module.exports = {"inputContainer":"CustomerWiseAPISalesConsumptionPage_inputContainer__29xPj"};